import React from 'react';
import {
  Text, StyleSheet, TextStyle, ViewStyle,
} from 'react-native';
import Colors from '../constants/Colors';
import isMobile from './IsMobile';
import PressableStyled from './PressableStyled';

interface ButtonProps {
  title?: string,
  affirmative?: boolean,
  onPress?: () => void,
  disabled?: boolean,
  style?: ViewStyle,
  textStyle?: TextStyle,
  children?,
  testID?: string,
  noShadow?: boolean,
}

const Button = ({
  affirmative = false,
  onPress = () => null,
  title = '',
  disabled = false,
  style,
  textStyle,
  children,
  testID,
  noShadow = false,
}: ButtonProps) => <PressableStyled
  {...{ disabled, onPress, testID }}
  style={[
    styles.container, !noShadow && styles.containerShadow, affirmative && styles.affirmative,
    disabled && styles.disabled, style,
  ]}>
    {!!title && <Text style={[
      styles.title,
      affirmative && styles.affirmativeText,
      textStyle,
    ]}
    selectable={false}>
      {title}
    </Text>}
    {children}
  </PressableStyled>;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 5,
    height: isMobile ? 40 : 36,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    borderWidth: 1,
    backgroundColor: '#FFF',
    borderColor: Colors.light.hereworksBlue500,
    alignSelf: 'center',
    flexDirection: 'row',
    flex: isMobile ? 1 : undefined,
  },
  containerShadow: {
    shadowOpacity: 0.06,
    shadowRadius: 2,
    elevation: 2,
    shadowOffset: { width: 2, height: 4 },
    shadowColor: '#323247',
  },
  title: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlue500,
  },
  affirmative: {
    backgroundColor: Colors.light.hereworksBlue500,
    marginStart: 12,
  },
  affirmativeText: {
    color: '#FFF',
  },
  disabled: {
    opacity: 0.5,
  },
});

export default Button;
